import React from 'react'
import Button from '../../atoms/button/button'
import './solveYourDoubts.scss'
import Title from '../../atoms/title/title'
import useMediaQuery from '../../../utils/useMediaQuery'
import { siteUrl } from '../../../shared/utils/siteUrl'
import { Link } from 'gatsby'

const SolveYourDoubts = () => {
  const isMobile = useMediaQuery()
  var homeLink = siteUrl + '/'

  return (
    <>
      <section className='f-section-solve-your-doubts'>
        <div className='f-section-solve-your-doubts__wrapper'>
          <Title color='yellow' txt={['Resuelve', 'tus dudas?']} />
          <p className='f-section-solve-your-doubts__description'>
            En NosotrasOnline siempre hay alguien para aconsejarte. Consulta con
            nuestra Ginecóloga sobre salud femenina y con nuestra Psicóloga temas
            como bullying, relaciones, autoestima y más.
          </p>
          <div className='f-section-solve-your-doubts__specialists'>
            <div className='f-section-solve-your-doubts__specialists__gynecologist'>
              <h3 className='f-section-solve-your-doubts__specialists__title'>
                Ella es nuestra <span>Ginecóloga</span>
              </h3>
              {!isMobile && (
                <div className='f-section-solve-your-doubts__button ginecologa'>
                  <Button
                    text='Consultar'
                    color='purple'
                    action={() => {
                      try {
                        window.dataLayer.push({
                          event: 'ga_event',
                          category: 'Vive el Cole :: Home',
                          action: 'Click :: Ginecologa',
                          label: 'Consultar',
                          value: '',
                        })
                      } catch (error) {
                        console.log('Datalayer error:', error)
                      }
                      window.open(
                        homeLink + 'entre-nosotras/consultorios/ginecologa/',
                      )
                    }}
                  />
                </div>
              )}
            </div>
            <div
              className={`f-section-solve-your-doubts__specialists__psychology ${process.env.LOCALE}`}
            >
              <h3 className='f-section-solve-your-doubts__specialists__title'>
                Ella es nuestra <span>Psicóloga</span>
              </h3>

              {!isMobile && (
                <div className='f-section-solve-your-doubts__button psicologa'>
                  <Button
                    text='Consultar'
                    color='purple'
                    action={() => {
                      try {
                        window.dataLayer.push({
                          event: 'ga_event',
                          category: 'Vive el Cole :: Home',
                          action: 'Click :: Psicologa',
                          label: 'Consultar',
                          value: '',
                        })
                      } catch (error) {
                        console.log('Datalayer error:', error)
                      }
                      window.open(
                        homeLink + 'entre-nosotras/consultorios/psicologa/',
                      )
                    }}
                  />
                </div>
              )}
            </div>
          </div>

          {isMobile ? (
            <div className='f-section-solve-your-doubts__button'>
              <Button
                text='Consultar'
                color='purple'
                action={() => {
                  window.open(homeLink + 'entre-nosotras/consultorios/')
                }}
              />
            </div>
          ) : (
            <p className='f-section-solve-your-doubts__description'>
              Nuestros consultorios son espacios privados y confiables para que
              siempre te sientas segura de resolver tus dudas con Nosotras.
            </p>
          )}
        </div>
      </section>

      <div className='f-terms-activity'>
        <Link to={'/terminos-y-condiciones'}>Términos y condiciones de la actividad</Link>
      </div>
    </>
  )
}

export default SolveYourDoubts
